import { atom, selector } from 'recoil';
import { PassingsService } from 'api';
export const getPassingsFilterPagination = atom({
  key: 'getPassingsFromFilterPagination',
  default: {
    max: 10,
    offset: 0
  }
});
export const showCheckboxColumn = atom({
  key: 'showCheckboxColumn',
  default: false
});
export const passingsToExport = atom({
  key: 'passingsToExport',
  default: []
});
export const getPassingsFilterOBEs = atom({
  key: 'getPassingsFilterOBEs',
  default: []
});
export const getPassingsFilterAgreements = atom({
  key: 'getPassingsFilterAgreements',
  default: []
});
export const getFilteredPassings = selector({
  key: 'getFilteredPassings',
  get: async ({
    get
  }) => {
    const pagination = get(getPassingsFilterPagination);
    const obes = get(getPassingsFilterOBEs);
    try {
      return await PassingsService.getPassingsForObes({
        body: {
          ...pagination,
          obeNumbers: obes
        }
      });
    } catch (e) {
      console.error(e);
    }
    return {};
  }
});